import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from "../../shared/services/cart-service";
import { EitCart } from '../../shared/classes/eitcart';
import { TypePayment, DB, Paypal } from '../../shared/services/env.service';
import { TypeOrder, ET_OpzioniCoupon } from '../../shared/services/config-app';
import { EdenredService } from "../../shared/services/edenred-service";
import {
  IPayPalConfig,
  ICreateOrderRequest
} from 'ngx-paypal';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-paypalpay',
  templateUrl: './paypalpay.component.html',
  styleUrls: ['./paypalpay.component.scss']
})
export class PaypalpayComponent implements OnInit, OnDestroy {
 
  public cartData: any = {};
  public typeOrder: any = TypeOrder;
  public payType: any = TypePayment;
  public payPalConfig?: IPayPalConfig;
  public token: any = "";
  public vouchers = null;
  cartSub: Subscription;
  init = false;


  constructor(private route: ActivatedRoute, private router: Router,
    private cartService: CartService, private eService: EdenredService) {

    this.cartData = new EitCart();
    this.cartSub = new Subscription;
    this.token = null;
    this.vouchers = null;
    this.init = false;


  }

  ngOnInit(): void {
    this.token = this.eService.getToken();
    this.vouchers = this.eService.getVouchers();

    this.cartSub.add(this.cartService.cartObs.subscribe(x => {

      if (x) {
        this.cartData = x;
        this.initConfig();
      }

    }));
    /*this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.vouchers = JSON.parse(params['vouchers']);
    });*/

  }

  ngOnDestroy() {
    this.cartSub.unsubscribe();
  }

  goToPay() {
    this.router.navigate(['/checkpay'], { queryParams: {} });
  }

  orderResidual() {
    var result = this.cartData.order.euro_total + this.cartData.order.euro_tip - this.vouchers.available_amount / 100;

    return result.toFixed(2);
  }

  orderPay() {
    var result = (this.cartData.order.euro_total + this.cartData.order.euro_tip).toFixed(2);

    if (this.cartData && this.cartData.order.payment_id == TypePayment.TICKET) {
      result = this.orderResidual();
    }

    return result;
  }


  closeOrder(response) {

    if (this.cartData && this.cartData.order.payment_id == TypePayment.TICKET) {
      this.closeOrderEdenred(response);
    } else {
      this.closeOrderPaypal(response);
    }
  }

  closeOrderPaypal(response) {
    var dataPaypal: any = {};
    dataPaypal.restid = this.cartData.rest_id;
    dataPaypal.orderid = this.cartData.order_id;
    dataPaypal.type = TypePayment.PAYPAL;
    dataPaypal.payment = {};
    dataPaypal.response = {};
    dataPaypal.response.response = response;
    dataPaypal.noteride = "";
    let noteride = localStorage.getItem("noteride");
    if (noteride != undefined && noteride != "undefined" && noteride != null && noteride != "null") {
      dataPaypal.noteride = noteride;
    }
    this.cartService.finalize(dataPaypal);
  }

  closeOrderEdenred(response) {
    var dataPaypal: any = {};
    dataPaypal.restid = this.cartData.rest_id;
    dataPaypal.orderid = this.cartData.order_id;
    dataPaypal.type = TypePayment.TICKET;
    dataPaypal.stype = TypePayment.PAYPAL;
    dataPaypal.token = this.token;
    dataPaypal.payment = {};
    dataPaypal.response = {};
    dataPaypal.response.response = response;
    dataPaypal.noteride = "";
    let noteride = localStorage.getItem("noteride");
    if (noteride != undefined && noteride != "undefined" && noteride != null && noteride != "null") {
      dataPaypal.noteride = noteride;
    }
    this.cartService.finalizeEdenred(dataPaypal, this.vouchers);
  }


  private initConfig(): void {

    if (!this.init) {
      this.init = true;
     // var tot = this.orderPay();
      var tot = (this.cartData.order.euro_total).toFixed(2);
      if(this.cartData.order.ismultiorder)
      {
        tot = (this.cartData.order.eurocarttotal).toFixed(2);
      }

      this.payPalConfig = {
        currency: 'EUR',
        clientId: this.cartData.PYKR,
        createOrderOnClient: (data) => <ICreateOrderRequest>{
          "intent": "CAPTURE",
          "purchase_units": [{
            "amount": {
              "currency_code": 'EUR',
              "value": String(tot),
            },

          }]
        },
        advanced: {
          commit: 'true',
          extraQueryParams: [ { name: "disable-funding", value:"mybank,sofort"} ]  
      },
      style: {
          label: 'paypal',
          layout: 'vertical'
      },
        onApprove: (data, actions) => {
          console.log('onApprove - transaction was approved, but not authorized', data, actions);
          actions.order.get().then(details => {
            console.log('onApprove - you can get full order details inside onApprove: ', details);
          });

        },
        onClientAuthorization: (data) => {
          console.log('onClientAuthorization - you should probably inform your server about completed transaction at this point', data);
          //this.showSuccess = true;
          var response = { state: "approved", id: data.id };
          this.token = this.eService.getToken();
          this.vouchers = this.eService.getVouchers();
          this.closeOrder(response);

        },
        onCancel: (data, actions) => {
          console.log('OnCancel', data, actions);
          //this.showCancel = true;


        },
        onError: err => {
          console.log('OnError', err);
          // this.showError = true;
        },
        onClick: (data, actions) => {
          console.log('onClick', data, actions);
          //this.resetStatus();
        },
        onShippingChange: function(data, actions) {
          if (data.shipping_address.country_code !== 'IT') {
              console.log('onShippingChange - data.shipping_address.country_code', data);
              return actions.reject();
          }
          console.log('onShippingChange - data.shipping_address.country_code', data);
          return actions.resolve();
      }
      };
    }
  }


}
